import React, { useState, useEffect } from 'react'
import NewsItem from './NewsItem';
import Spinner from './Spinner';
import PropTypes from 'prop-types'
import "./News.css"

const News = (props) => {

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  const updateNews = async () => {

    props.setProgress(10);
    setLoading(true);
    let data = await props.articles;
    props.setProgress(30);
    setArticles(data);
    props.setProgress(70);
    setLoading(false);
    props.setProgress(100);

  }

  useEffect(() => {
    document.title = `NewsAgent - ${capitalizeFirstLetter(props.category)}`;
    updateNews();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <h1 className="text-center" style={{ margin: '35px 0px', marginTop: '90px', color: props.mode === 'light' ? 'black' : 'white' }}><strong>NewsAgent - Top {capitalizeFirstLetter(props.category)} Headlines</strong></h1>
      {loading && <Spinner />}
      <div className='container'>
        <div className='row' >
          {articles.map((item) => {
            return <div className='col-sm-12 col-md-6 col-lg-4 col-xl-3 col-xll-4 mb-3 d-flex align-items-stretch' key={item.url}>
              <NewsItem
                mode={props.mode}
                author={item.author}
                title={item.title ? item.title : ""}
                description={item.description ? item.description : ""}
                imageUrl={item.urlToImage ? item.urlToImage : "https://react.semantic-ui.com/images/wireframe/image.png"}
                newsUrl={item.url}
                time={item.publishedAt ? item.publishedAt : "unknown"}
                source={item.source.name ? item.source.name : ""} />
            </div>
          })}
        </div>
      </div>
    </>
  );
}

News.defaultProps = {
  country: "in",
  pageSize: "8",
  category: "general"
}

News.propTypes = {
  country: PropTypes.string,
  pageSize: PropTypes.string,
  category: PropTypes.string
}

export default News;